function countdown(endDate, element) {
  var timer, days, hours, minutes, seconds;
  endDate = new Date(endDate).getTime();
  
  if (isNaN(endDate)) {
    return;
  }

  // Immediately hide if the countdown is already over.
  if (endDate - new Date().getTime() <= 0) {
      element.style.display = "none";
      return;
  }
  
  timer = setInterval(calculate, 1000);
  
  function calculate() {
    var startDate = new Date();
    var startDate = startDate.getTime();
    
    var timeRemaining = parseInt((endDate - startDate) / 1000);
    
    if (timeRemaining >= 0) {
      days = parseInt(timeRemaining / 86400);
      timeRemaining = timeRemaining % 86400;
      
      hours = parseInt(timeRemaining / 3600);
      timeRemaining = timeRemaining % 3600;
      
      minutes = parseInt(timeRemaining / 60);
      timeRemaining = timeRemaining % 60;
      
      seconds = parseInt(timeRemaining);
      
      // display countdown on the element
      element.innerHTML = ' <span class="highlight1">DEAL ENDS IN ' + days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's</span>';
    } else {
      clearInterval(timer);
      // Hide the element when the countdown ends
      element.style.display = "none";
    }
  }
}
